import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import LandingPageAppResource from './LandingPageAppResource';
import LuLandingPageSectionTypeAppResource from './LuLandingPageSectionTypeAppResource';
import LandingPageHomeLoanOfficerAppResource from "./LandingPageHomeLoanOfficerAppResource";
import LandingPageHomeBabyOrAdoptionAppResource from "./LandingPageHomeBabyOrAdoptionAppResource";
import LandingPageHomeTopicOfInterestAppResource from "./LandingPageHomeTopicOfInterestAppResource";

class LandingPageHomeSectionAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'landing-page-home-section';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'landings/pages/homes/sections';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'landingPageUuid',
            'landingPageSectionTypeId',
            'coverFileUuid',
            'headline',
            'introduction',
            'body',
            'benefits',
            'actionButtonText',
            'landingPage',
            'type',
            'cover',
            'babyOrAdoption',
            'loanOfficer',
            'topicOfInterest',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            landingPage: LandingPageAppResource,
            type: LuLandingPageSectionTypeAppResource,
            cover: FileAppResource,
            babyOrAdoption: LandingPageHomeBabyOrAdoptionAppResource,
            loanOfficer: LandingPageHomeLoanOfficerAppResource,
            topicOfInterest: LandingPageHomeTopicOfInterestAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            landingPage: 'landing_page_uuid',
            type: 'landing_page_section_type_id',
            cover: 'cover_file_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        let rules = {
            landingPageUuid: {
                type: 'string',
            },
            landingPageSectionTypeId: {
                type: 'integer',
                presence: true,
            },
            coverFileUuid: {
                type: 'string',
            },
            headline: {
                type: 'string',
                presence: true,
                length: {
                    minimum:1,
                    maximum: 255,
                    tooShort:'is required!'
                },
            },
            introduction: {
                type: 'string',
                length: {
                    maximum: 1000,
                },
            },
            body: {
                type: 'string',
            },
            actionButtonText: {
                type: 'string',
                presence: true,
                length: {
                    minimum:1,
                    maximum: 255,
                    tooShort:'is required!'
                },
            },
            benefits: {
                arrayOfObjects: {
                    value: {
                        length: {
                            minimum: 3,
                            maximum: 255,
                        },
                    },
                    status: {
                        presence: true,
                    },
                },
            },
        };

        if (! this.exists) {
            delete rules.headline.presence;
        }

        return rules;
    }
}

export default LandingPageHomeSectionAppResource;
